import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormPrevious = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormPrevious' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='9 6 15 12 9 18' transform='matrix(-1 0 0 1 24 0)' />
  </StyledIcon>
);
